import { FormContext } from './types';
import { Form } from './types/form.type';

export function getPaymentMethodId(form: Form | FormContext) {
    return form.paymentMethodId || 'CDPaymentMethod';
}
